import { all, call, put, takeLatest, select } from 'redux-saga/effects'
import { ItemsPerPage } from '../Redux/genericReducers'
import ShopifyProductAction, {
  ShopifyProductTypes,
  ShopifyProductSelectors,
} from '../Redux/ShopifyProductRedux'

export function* detailsRequest(api, action) {
  const resp = yield call(api.getProductDetails, {
    product_uuid: action.id,
    show_product_data: !!action.showProductData,
  })
  if (resp.ok) {
    yield put(
      ShopifyProductAction.shopifyProductDetailSuccess({
        ...resp.data.data,
        product_data: resp.data.product_data,
      })
    )
  } else {
    yield put(
      ShopifyProductAction.shopifyProductDetailFailure('something went wrong')
    )
  }
}

export function* getAll(api, action) {
  const resp = yield call(api.getShopifyProducts, action.params)
  if (resp.ok) {
    yield put(
      ShopifyProductAction.shopifyProductListSuccess(resp.data.data || [])
    )
  } else {
    yield put(
      ShopifyProductAction.shopifyProductListFailure('something went wrong')
    )
  }
}

export function* getActivatedProducts(api, action) {
  console.log('here here her')
  let params = action.params || {}
  if (typeof action.activatedListOffset !== 'undefined') {
    params.offset = action.activatedListOffset
  } else {
    const activatedListOffset = yield select(
      ShopifyProductSelectors.activatedListOffset
    )
    params.offset = activatedListOffset
  }

  params.limit = ItemsPerPage

  const resp = yield call(api.getProducts, params)
  if (resp.ok) {
    yield put(ShopifyProductAction.activatedProductListSuccess(resp.data))
    if (action.callback) {
      action.callback(resp.data)
    }
  } else {
    yield put(
      ShopifyProductAction.activatedProductListFailure('something went wrong')
    )
  }
}

export function* getActivatedFixedApptProducts(api, action) {
  const resp = yield call(api.getProducts, { type: 'fixed' })
  if (resp.ok) {
    yield put(
      ShopifyProductAction.activatedFixedApptProductListSuccess(resp.data)
    )
  } else {
    yield put(
      ShopifyProductAction.activatedFixedApptProductListFailure(
        'something went wrong'
      )
    )
  }
}

export function* onUpdate(api, action) {
  let success = true

  for (let i = 0; i < action.params.length; i++) {
    const p = action.params[i]
    const resp = yield call(api.updateProduct, p)
    if (!resp.ok) {
      success = false
    }
  }

  if (success) {
    yield put(ShopifyProductAction.shopifyProductsUpdateSuccess())
    const activatedListOffset = yield select(
      ShopifyProductSelectors.activatedListOffset
    )
    yield put(
      ShopifyProductAction.activatedProductListRequest({
        offset: activatedListOffset || 0,
      })
    )
    yield put(ShopifyProductAction.activatedFixedApptProductListRequest())
    action.callback()
  } else {
    ShopifyProductAction.shopifyProductsUpdateFailure('something went wrong')
    action.callback('failure')
  }
}

export function* shopifyProductsSearchRequest(api, action) {
  const resp = yield call(api.searchShopifyProducts, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export function* createShopifyProduct(api, action) {
  const resp = yield call(api.createShopifyProduct, action.params)
  if (resp.ok) {
    action.callback(resp.data)
  }
}

export default function* authSagas(api) {
  yield all([
    takeLatest(
      ShopifyProductTypes.SHOPIFY_PRODUCT_DETAIL_REQUEST,
      detailsRequest,
      api
    ),
    takeLatest(ShopifyProductTypes.SHOPIFY_PRODUCT_LIST_REQUEST, getAll, api),
    takeLatest(
      ShopifyProductTypes.ACTIVATED_PRODUCT_LIST_REQUEST,
      getActivatedProducts,
      api
    ),
    takeLatest(
      ShopifyProductTypes.ACTIVATED_FIXED_APPT_PRODUCT_LIST_REQUEST,
      getActivatedFixedApptProducts,
      api
    ),
    takeLatest(
      ShopifyProductTypes.SHOPIFY_PRODUCTS_UPDATE_REQUEST,
      onUpdate,
      api
    ),
    takeLatest(
      ShopifyProductTypes.SHOPIFY_PRODUCTS_SEARCH_REQUEST,
      shopifyProductsSearchRequest,
      api
    ),
    takeLatest(
      ShopifyProductTypes.CREATE_SHOPIFY_PRODUCT,
      createShopifyProduct,
      api
    ),
  ])
}
